import TestimonialsGallery from "../common/testimonials-gallery";
import { mainPageLgTestimonials } from "../../data/largeTestimonials";
import TestimonialsMessage from "../common/testimonial-message";
import { glucoGenTestimonialsWithoutD } from "../../data/testimonials";


const TestimonialsMain = () => (
    <section id="testimonials" className="gg-bg-solid-green-light">
        <div className="container-fluid py-5">
            <div className="row justify-content-center align-items-center">
                <div className="col-11">
                    <div className="row justify-content-center align-items-center pb-3">
                        <div className="col-md-10 text-center">
                            <h2 className="fw-bold mb-0">They want you to feel great too.</h2>
                            <h2 className="fw-bold">Meet our real customers.</h2>
                        </div>
                    </div>
                    <TestimonialsGallery
                        largeTestimonials={mainPageLgTestimonials} />
                    <TestimonialsMessage
                        testimonials={glucoGenTestimonialsWithoutD} />
                </div>
            </div>
        </div>
    </section>
)

export default TestimonialsMain;